import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { loadSystemMessages } from 'app/menu/components/SystemMessage/state/actions'
import { GETFilteredMessagesResponse } from '@cbgms/api/modules/messages'

const MESSAGES_RELOAD_TIME = 15 * 60 * 1000 // Refresh every 15 minutes

export const useSystemMessages = () => {
  const dispatch = useDispatch()
  return useQuery(
    ['system-messages'],
    async () => {
      const { Data } = (await dispatch(loadSystemMessages())) as any as GETFilteredMessagesResponse
      return Data
    },
    { refetchIntervalInBackground: true, refetchInterval: MESSAGES_RELOAD_TIME, staleTime: MESSAGES_RELOAD_TIME }
  )
}
